import generalActionTypes from "../types/generalActionTypes";

const initialState = {
    stateInfo: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        error: null
    },
    landingPageUrl: null,
    appVersion: null,
};

const generalReducer = (state = initialState, action) => {
    switch (action.type) {
        // ************* Landing Page URL ************* 
        case generalActionTypes.START_GET_LANDING_PAGE_URL:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: true,
                    isSuccess: false,
                    isError: false,
                    error: null
                }
            };

        case generalActionTypes.GET_LANDING_PAGE_URL_SUCCESS:
            return {
                ...state,
                landingPageUrl: action.payload,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false,
                    isSuccess: true,
                    isError: false,
                    error: null
                }
            };

        case generalActionTypes.GET_LANDING_PAGE_URL_FAILURE:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false,
                    isSuccess: false,
                    isError: true,
                    error: 'Failed to fetch landing page URL'
                }
            };

        default:
            return state;
    }
};

export default generalReducer;

